import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setLangChange } from './core/redux/action';
import { GrLanguage } from "react-icons/gr";

const LanguageSelector = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  const languages = [
    { key: 'en', label: 'English' },
    { key: 'ja', label: 'Japanese' },
  ];

  // Set the language from localStorage on initial load
  useEffect(() => {
    const savedLang = localStorage.getItem('lang');
    if (savedLang) {
      setSelectedLanguage(savedLang); 
    }
  }, []);

  const changeLanguage = (lng) => {
    if (selectedLanguage !== lng) {
      localStorage.setItem('lang', lng); 
      dispatch(setLangChange(lng));
      setSelectedLanguage(lng); 
    }
    setIsOpen(false); 
  };

  return (
    <div className="language-selector">
      <button 
        className="dropdown-header" 
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label="Select language"
      >
        <GrLanguage className="icon" />
      </button>
      {isOpen && (
        <ul className="dropdown-options" role="menu">
          {languages.map((lang) => (
            <li 
              key={lang.key} 
              className={`dropdown-item ${lang.key === selectedLanguage ? 'selected' : ''}`}
              onClick={() => changeLanguage(lang.key)}
              role="menuitem"
            >
              {lang.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSelector;
